import { api } from './client'

export type DkBooksStatus = {
  connected: boolean
  base_url: string
  token_prefix?: string
  dkbooks_user?: { id: number; email: string; name: string; role: string }
  error?: string
}

export type TimeEntry = {
  id: number
  entry_date: string
  duration_minutes: number
  notes: string | null
  status: 'billed' | 'unbilled' | null
  service_name: string | null
  user_name: string | null
}

export type TimeSummary = {
  configured: boolean
  total_minutes: number
  billed_minutes: number
  unbilled_minutes: number
  entries_count: number
  estimate_minutes: number | null
  estimate_points: number | null
  recent_entries: TimeEntry[]
}

export async function getDkBooksStatus(): Promise<DkBooksStatus> {
  return api<DkBooksStatus>('/me/dkbooks')
}

export async function setDkBooksToken(token: string, baseUrl?: string): Promise<DkBooksStatus> {
  return api<DkBooksStatus>('/me/dkbooks', {
    method: 'PUT',
    body: { token, base_url: baseUrl ?? 'https://dkbooks.diretek.com' },
  })
}

export async function clearDkBooksToken(): Promise<void> {
  return api<void>('/me/dkbooks', { method: 'DELETE' })
}

export async function getStoryTimeSummary(storyId: number): Promise<TimeSummary> {
  return api<TimeSummary>(`/stories/${storyId}/time-summary`)
}

export async function logStoryTime(
  storyId: number,
  data: { duration_minutes: number; notes?: string; entry_date?: string },
): Promise<{ dkbooks_time_entry: unknown; story_key: string }> {
  return api<{ dkbooks_time_entry: unknown; story_key: string }>(
    `/stories/${storyId}/time-log`,
    { method: 'POST', body: data },
  )
}
